// default
export const SYSTEM = 'system';
export const SYSTEM_SLICE_NAME = `${SYSTEM}Slice`;

// action
export const GET_MAIN_SYSTEM_LIST = `${SYSTEM}/getMainSystem`;
export const GET_SYSTEM_LIST = `${SYSTEM}/getSystem`;
export const GET_DESIGNATION_LIST = `${SYSTEM}/getDesignation`;
export const GET_DISCIPLINE_LIST = `${SYSTEM}/getDiscipline`;
export const GET_SYSTEM_SUB_LIST = `${SYSTEM}/getSystemSub`;
export const POST_SYSTEM = `${SYSTEM}/postSystem`;
export const UPDATE_SYSTEM = `${SYSTEM}/updateSystem`;
export const DELETE_SYSTEM = `${SYSTEM}/deleteSystem`;
export const GET_SYSTEM_SUB_ALL_LIST = `${SYSTEM}/getSystemSubAll`;
export const GET_MULTI_SYSTEM_LIST = `${SYSTEM}/getMultiSystemList`;
export const GET_ADD_NATION_SYSTEM_LIST = `${SYSTEM}/getAddNationSystemList`;

// actions
export const actions = {
  GET_MAIN_SYSTEM_LIST,
  GET_SYSTEM_LIST,
  GET_DESIGNATION_LIST,
  GET_DISCIPLINE_LIST,
  GET_SYSTEM_SUB_LIST,
  POST_SYSTEM,
  UPDATE_SYSTEM,
  DELETE_SYSTEM,
  GET_SYSTEM_SUB_ALL_LIST,
  GET_MULTI_SYSTEM_LIST,
  GET_ADD_NATION_SYSTEM_LIST
};
